import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
import { dielineInfoSchema } from "./dieline.js";
import { pouchTypeSchema } from "./pouchType.js";
export const websiteDataSchema = z.object({
    _id: z.string().optional(),
    pouchType: pouchTypeSchema,
    pouchTypeFR: z.string().describe("Pouch Type (French)"),
    descriptionEN: z.string().describe("Description (English)"),
    descriptionFR: z.string().describe("Description (French)"),
    image: z.string().url(),
    sizes: z
        .array(z.object({
        dimensions: z
            .object({
            width: z.number().describe("Width (mm)"),
            height: z.number().describe("Height (mm)"),
            gusset: z
                .number()
                .optional()
                .describe(createCustomSettings({
                label: "Gusset (mm)",
            })),
        })
            .describe("Dimensions"),
        maxFill: z.number().optional().describe("Maximum Fill (Cups)"),
        reccFill: z.number().optional().describe("Recommended Fill (Cups)"),
        dielines: z
            .array(z.object({ id: z.string().describe("ID") }))
            .describe("Dieline File"),
    }))
        .describe("Pouch Size"),
});
export const resolvedWebsiteDataSchema = websiteDataSchema.extend({
    sizes: z.array(websiteDataSchema.shape.sizes.element.omit({ dielines: true }).extend({
        dielines: z.array(dielineInfoSchema),
    })),
});
//# sourceMappingURL=websiteData.js.map